/* eslint-disable */
import './libs/client-ids';
import { sentryInit } from './libs/sentry';
import { isSafariInit } from './libs/isSafari';
import { retailRocketInit } from './libs/retail-rocket';

sentryInit();
isSafariInit();
retailRocketInit();
/* eslint-enable */
